import { render, staticRenderFns } from "./AffiliatePerformancePlanWise.vue?vue&type=template&id=824c619a&"
import script from "./AffiliatePerformancePlanWise.vue?vue&type=script&lang=js&"
export * from "./AffiliatePerformancePlanWise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports